import type { LayoutEngine } from './types';
import { horizontalTreeLayout } from './horizontalTree';
import { radialLayout } from './radialLayout';
import { verticalTreeLayout } from './verticalTreeLayout';

/**
 * Returns the layout engine for the given layout type string.
 * Falls back to horizontal tree if the type is unrecognized.
 */
export function getLayoutEngine(layoutType: string): LayoutEngine {
  switch (layoutType) {
    case 'radial':
      return radialLayout;
    case 'vertical-tree':
      return verticalTreeLayout;
    case 'horizontal-tree':
    default:
      return horizontalTreeLayout;
  }
}
